"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sessionService = void 0;
var local_storage_service_1 = require("./local-storage.service");
var LOCAL_STORAGE_NAME_TOKEN = 'isAuthenticated';
function storeAsAuthenticated() {
    local_storage_service_1.localStorageService.set(LOCAL_STORAGE_NAME_TOKEN, 'true');
}
function revokeAuthentication() {
    local_storage_service_1.localStorageService.removeItem(LOCAL_STORAGE_NAME_TOKEN);
}
function getToken() {
    return local_storage_service_1.localStorageService.get(LOCAL_STORAGE_NAME_TOKEN);
}
function isAuthenticated() {
    var token = getToken();
    return token != null;
}
exports.sessionService = {
    storeAsAuthenticated: storeAsAuthenticated,
    revokeAuthentication: revokeAuthentication,
    getToken: getToken,
    isAuthenticated: isAuthenticated,
};
